<template>
    <div class="apprenticeInfoPage">
        <div class="over">
            <div class="bgBox"><img src="./../../../assets/home/bg-top.png" alt=""></div>
        </div>
        <div class="top"></div>
        <div class="header">
            <i @click="goback"> <img src="./../../../assets/home/back.jpg" alt=""> </i>
            <span>我的徒弟</span>
        </div>
        <div class="content">
            <div class="buttonBox">
                <div class="apprentice" @click="changeApprentice">
                    <span style="font-size:24px; border-bottom:2px solid #FFD15A" ref="changeApprentice">徒弟</span>
                </div>
                <div class="disciple" @click="changeDisciple">
                    <span ref="changeDisciple">徒孙</span>
                </div>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        changeApprentice(){
            this.$refs.changeApprentice.style.fontSize = "0.24rem"
            this.$refs.changeApprentice.style.borderBottom = "2px solid #FFD15A"
            this.$refs.changeDisciple.style.fontSize = "0.18rem"
            this.$refs.changeDisciple.style.borderBottom = "none"
            this.$router.push({path:"/home/apprentice/apprenticeinfo/apprentices"})
        },
        changeDisciple(){
            this.$refs.changeApprentice.style.fontSize = "0.18rem"
            this.$refs.changeApprentice.style.borderBottom = "none"
            this.$refs.changeDisciple.style.fontSize = "0.24rem"
            this.$refs.changeDisciple.style.borderBottom = "2px solid #FFD15A"
            this.$router.push({path:"/home/apprentice/apprenticeinfo/disciples"})
        },
        goback(){
            this.$router.push({path:"/home/apprentice"})
        }
    },
    
}
</script>

<style lang="scss" scoped>
    .over{
        width:100%;
        height:.60rem;
        overflow: hidden;
        position: absolute;
        top:0;
        z-index: -1;
    }
    .bgBox{
        width:100%;
        height:2.32rem;
    }
    .top{
        height:20px;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .content{
        width:100%;
        background:#fff;
        padding:0 5%;
        .buttonBox{
            height:.65rem;
            width:100%;
            display:flex;
            align-items: center;
            justify-content: space-around;
            div{
                width:1.50rem;
                height:.33rem;
                font-size: .18rem;
                background:transparent;
                border:none;
                text-align: center;
                line-height: .33rem;
                span{
                    padding-bottom:.05rem;
                }
            }
        }
        
    }
</style>

